import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Box, CircularProgress } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import EmailIcon from '@mui/icons-material/Email';
import { useDispatch } from 'react-redux';
import JwtService from '../../auth/services/jwtService';
import { showMessage } from 'app/store/fuse/messageSlice';
import { verifyMagicLink } from '../../store/twoFAlice';

function MagicLinkRedirectPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    useEffect(() => {
        if (token) {
            handleVerify(token);
        } else {
            dispatch(showMessage({ message: "No token provided", variant: "error" }));
            navigate('/login');
        }
    }, [token, dispatch, navigate]);

    const handleVerify = (token) => {
        debugger
        dispatch(verifyMagicLink({ token }))
            .unwrap()
            .then((res) => {
                JwtService.twoFaLogin(res);
            })
            .catch((errors) => {
                if (Array.isArray(errors)) {
                    errors.forEach((error) => {
                        dispatch(showMessage({ message: error?.message || "Error", variant: "error" }));
                    });
                } else {
                    dispatch(showMessage({ message: errors || "Verification failed", variant: "error" }));
                }

                setTimeout(() => {
                    navigate('/login');
                }, 1500)
            });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                px: 2,
                bgcolor: 'background.default',
            }}
        >
            <Paper
                sx={{
                    width: '100%',
                    maxWidth: 400,
                    p: 4,
                    borderRadius: 2,
                    boxShadow: 3,
                    textAlign: 'center',
                }}
            >
                <img
                    src="/assets/images/logo/logo.svg"
                    alt="logo"
                    style={{ width: 100, margin: '0 auto' }}
                />

                <Typography variant="h6" sx={{ mt: 3 }}>
                    Authenticating your access via magic link
                </Typography>

                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress color='secondary' />
                </Box>
            </Paper>
        </Box>
    );
}

export default MagicLinkRedirectPage;